import {Confirm} from "../../../confirm/confirm";

export function initEditmap() {
    $('.map-upload [data-upload-button]').click((e : JQuery.TriggeredEvent) => {
        $(e.target).attr('disabled', 'disabled').addClass('loading');
        $(e.target).closest('form').submit();
    });
    
    $('.map-upload [data-delete-button]').click((e : JQuery.TriggeredEvent) => {
        e.preventDefault();
        
        new Confirm('Do you really want to delete this map?', () => {
            $(e.target).attr('disabled', 'disabled').addClass('loading');
            document.location.href = $(e.target).attr('href');
        }, () => {});
    });
    
    $('.map-upload [data-overwrite-button]').click((e : JQuery.TriggeredEvent) => {
        e.preventDefault();
        
        new Confirm('Do you really want to overwrite this map?', () => {
            $(e.target).attr('disabled', 'disabled').addClass('loading');
            $(e.target).closest('form').submit();
        }, () => {});
    });
}
